module.exports = __webpack_public_path__ + "img/vn.f453abf1.svg";